import z from "zod";

export enum EGenerationStatus {
  REQUESTED = "requested",
  PROCESSING = "processing",
  SUCCESS = "success",
  FAILURE = "failure",
}

export const generationStatusSchema = z.nativeEnum(EGenerationStatus);
